import type { ConversationScript } from "@ui/components/heroes/HeroConversationalAI/useChatAnimation";

// Sample Lyrics - Variant 1 (Dark/Atmospheric)
export const SAMPLE_INTRO_1 = `In the shadows where the beats collide,
Feel the rhythm, let the music guide.
Echoes of the night, pulsing through the air,
Lost in the moment, without a care.

Synths are rising, taking us higher,
Dancing in the dark, fueled by desire.
Whispers of the bass, a hypnotic call,
Together we'll surrender, let the night enthrall.`;

export const SAMPLE_VERSE1_1 = `Midnight pulse beneath our feet,
City lights and hearts that beat.
Moving through the electric haze,
Lost inside these endless days.

Shadows dancing on the wall,
Answering the rhythm's call.
In this space between the real,
Music makes us truly feel.`;

// Sample Lyrics - Variant 2 (Like Sample 1 but mentions ElevenLabs)
export const SAMPLE_INTRO_2 = `In the shadows where the beats collide,
ElevenLabs creates the sound that guides.
Echoes of the night, pulsing through the air,
Lost in the moment, without a care.`;

export const SAMPLE_VERSE1_2 = `Midnight pulse beneath our feet,
City lights and hearts that beat.
Moving through the electric haze,
Lost inside these endless days.

Shadows dancing on the wall,
Answering the rhythm's call.
In this space between the real,
Music makes us truly feel.`;

// Sample Lyrics - Variant 3 (Like Sample 2 but more dramatic verse)
export const SAMPLE_INTRO_3 = `In the shadows where the beats collide,
ElevenLabs creates the sound that guides.
Echoes of the night, pulsing through the air,
Lost in the moment, without a care.
`;

export const SAMPLE_VERSE1_3 = `Thunder crashes through the storm,
Electric souls begin to transform.
Blazing through the endless night,
Burning with forbidden light.

Demons dancing on the edge,
Making their eternal pledge.
In this realm of pure emotion,
Music drowns us like an ocean.`;

// Sample Lyrics - Variant 4 (Like Sample 3 but shorter intro - 6 lines)
export const SAMPLE_INTRO_4 = `In the shadows where the beats collide,
ElevenLabs creates the sound that guides.`;

export const SAMPLE_VERSE1_4 = `Thunder crashes through the storm,
Electric souls begin to transform.
Blazing through the endless night,
Burning with forbidden light.

Demons dancing on the edge,
Making their eternal pledge.
In this realm of pure emotion,
Music drowns us like an ocean.`;

// Helper function to format lyrics with section titles
export function formatLyricsWithTitles(intro: string, verse1: string): string {
  return `Intro

${intro}

Verse 1

${verse1}`;
}

export const GENERATION_SCRIPTS: ConversationScript[] = [
  {
    id: "music-generation-loop",
    steps: [
      { type: "user", content: "Mention ElevenLabs in the intro" },
      {
        type: "assistant",
        content: {
          content: "Generating...",
          type: "toolCall",
          loadingText: "Generating...",
          loadingDuration: 2000,
          resultContent: formatLyricsWithTitles(SAMPLE_INTRO_2, SAMPLE_VERSE1_2),
        },
      },
      { type: "user", content: "Make the first verse more dramatic" },
      {
        type: "assistant",
        content: {
          content: "Creating...",
          type: "toolCall",
          loadingText: "Creating...",
          loadingDuration: 2000,
          resultContent: formatLyricsWithTitles(SAMPLE_INTRO_3, SAMPLE_VERSE1_3),
        },
      },
      { type: "user", content: "Make the song intro a bit shorter" },
      {
        type: "assistant",
        content: {
          content: "Refining...",
          type: "toolCall",
          loadingText: "Refining...",
          loadingDuration: 2000,
          resultContent: formatLyricsWithTitles(SAMPLE_INTRO_4, SAMPLE_VERSE1_4),
        },
      },
    ],
    autoStart: true,
    loop: true,
  },
];
